import { render, staticRenderFns } from "./bill-card-loader.vue?vue&type=template&id=67b3b6ee&scoped=true&"
import script from "./bill-card-loader.vue?vue&type=script&lang=js&"
export * from "./bill-card-loader.vue?vue&type=script&lang=js&"
import style0 from "./bill-card-loader.vue?vue&type=style&index=0&id=67b3b6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3b6ee",
  null
  
)

export default component.exports